import React, { Fragment, useEffect, useState, cloneElement } from "react";
import PropTypes, { shape } from "prop-types";
import { 
  setBasicInfo,
  getBasicInfo,
  getSessionStorageItem, 
  setSessionStorageItem, 
  SESSION_STORAGE_ACCOUNT_KEY, 
  SESSION_STORAGE_EMAIL_CAPTURE, 
  SESSION_STORAGE_SAVED_QUOTE_DATA } from "../../../../sessionStorage";
import SaveQuotePartnerReferral from "../../../Quoters/CustomizeTerm/SaveTermQuotePartnerReferral/SaveQuotePartnerReferral";
import Hero from "./Hero";
import ConsumerAction from "./ConsumerAction";
import CarrierLogos from "./CarrierLogos";
import About from "./About";
import PartnerSupport from "./PartnerSupport";
import ServiceValue from "./ServiceValue";
import CompareProducts from "./CompareProducts";
import Education from "./Education";
import PurchasingProcess from "./PurchasingProcess";
import Faq from "./Faq";
import Privacy from "./Privacy";
import Cta from "./Cta";

export default function Term3_1(props) {
  const { 
    heroImages,
    customContent,
    valueProps,
    sectionData,
    isAccountLandingOverride,
    isPermProductAvailable,
    action,
    scrollToElement } = props;
  const {
    heroData,
    basicInfoForm,
    aboutData,
    partnerSupportData,
    serviceValueData,
    compareProductsData,
    educationData,
    purchasingProcessData,
    ctaData,
    faqData,
    privacyData,
  } = sectionData;
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const emailCapture = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);
  const savedQuote = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
  const basicInfo = getBasicInfo();

  const [isQuoteSaved, setQuoteSaved] = useState(savedQuote.quoteSaved);
  const [errorMessage, setErrorMessage] = useState({ message: '', status: '' });

  const [saveQuoteData, setSaveQuoteData] = useState(null);
  const [saveQuoteContact, setSaveQuoteContact] = useState(savedQuote);

  const [enableInitialEmailCapture, setEnableInitialEmailCapture] = useState(accountObj.account.enableInitialEmailCapture);
  const [enableTimeoutEmailCapture, setEnableTimeoutEmailCapture] = useState(accountObj.account.enableTimeoutEmailCapture);
  const [initialEmailCaptureDisplayed, setInitialEmailCaptureDisplayed] = useState(emailCapture.initialEmailCaptureDisplayed || false);
  const [timeoutEmailCaptureDisplayed, setTimeoutEmailCaptureDisplayed] = useState(emailCapture.timeoutEmailCaptureDisplayed || false);
  const [enablePartnerReferralEmailCapture, setEnablePartnerReferralEmailCapture] = useState(emailCapture.enablePartnerReferralEmailCapture || false);
  const [isPartnerReferralEmailCaptureActive, setIsPartnerReferralEmailCaptureActive] = useState(emailCapture.isPartnerReferralEmailCaptureActive || false);
  const [modalSaveQuoteIsOpen, setModalSaveQuoteIsOpen] = useState(false);

  // ===========================================================================

  const customAboutSection = !!customContent.aboutSection ? JSON.parse(customContent.aboutSection) : null;
  const customPartnerSupportSection = !!customContent.partnerSupportSection ? JSON.parse(customContent.partnerSupportSection) : null;
  const customServiceValueSection = !!customContent.serviceValueSection ? JSON.parse(customContent.serviceValueSection) : null;
  const customCompareProductsSection = !!customContent.comparisonCtaSection ? JSON.parse(customContent.comparisonCtaSection) : null;
  const customEducationSection = !!customContent.educationSection ? JSON.parse(customContent.educationSection) : null;
  const customPurchasingProcessSection = !!customContent.purchasingProcessSection ? JSON.parse(customContent.purchasingProcessSection) : null;
  const customCtaFirstSection = !!customContent.callToActionSections ? JSON.parse(customContent.callToActionSections)[0] : null;
  const customCtaSecondSection = !!customContent.callToActionSections ? JSON.parse(customContent.callToActionSections)[1] : null;
  const customFaqSection = !!customContent.frequentlyAskedQuestionsSection ? JSON.parse(customContent.frequentlyAskedQuestionsSection) : null;
  const customPrivacySection = !!customContent.privacySection ? JSON.parse(customContent.privacySection) : null;

  const setCurrentSavedQuoteData = () => {
    const newData = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
    setSaveQuoteContact(newData);
  }

  const handleContactChange = (contact) => {
    setSaveQuoteContact(contact);
  };

  const setTimeoutEmailDisplayed = () => {
    setTimeoutEmailCaptureDisplayed(true);
  };

  const setInitialEmailDisplayed = () => {
    setInitialEmailCaptureDisplayed(true);
  };

  const setEmailPrefill = () => {
    setBasicInfo(basicInfo);
  };

  const onSubmit = () => {
    props.sectionData.setEmailCaptureActive(false);
    if (basicInfoForm.ref.current) {
      basicInfoForm.ref.current.onSubmit();
    }
  };

  useEffect(() => {
    if (saveQuoteContact.emailAddress !== "") {
      setSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA, {
        "quoteSaved": isQuoteSaved,
        "firstName": saveQuoteContact.firstName,
        "lastName": saveQuoteContact.lastName,
        "emailAddress": saveQuoteContact.emailAddress,
      });
    }
    setCurrentSavedQuoteData();
  }, [isQuoteSaved]);

  return (
    <Fragment>
      <Hero 
        heroText={heroData}
        isTestimonialPanel={props.sectionData.showTestimonialPanel} 
        heroImageUrl={heroImages.desktop}
        heroImageTabletUrl={heroImages.tablet}
        heroImageMobileUrl={heroImages.mobile}
        isAccountLandingOverride={isAccountLandingOverride}
        customHeroImageUrls={{
                              heroImageUrl: customContent.heroImageUrl,
                              heroImageTabletUrl: customContent.heroImageTabletUrl,
                              heroImageMobileUrl: customContent.heroImageMobileUrl,
                            }}
      />
      <ConsumerAction carrierLogos={<CarrierLogos />} basicInfo={
        cloneElement(basicInfoForm, 
          {
            setModalSaveQuoteIsOpen: setModalSaveQuoteIsOpen,
            setSaveQuoteData: setSaveQuoteData,
            saveQuoteContact: saveQuoteContact,
          })} emailCapture={emailCapture} />
      <About data={aboutData} customData={customAboutSection} />
      <PartnerSupport data={partnerSupportData} customData={customPartnerSupportSection} />
      <ServiceValue data={serviceValueData} customData={customServiceValueSection} scrollToElement={(anchor) => scrollToElement(anchor, 80)} />
      <CompareProducts data={compareProductsData} customData={customCompareProductsSection} isPermProductAvailable={isPermProductAvailable} action={action} />
      <Education data={educationData} customData={customEducationSection} />
      <PurchasingProcess data={purchasingProcessData} customData={customPurchasingProcessSection} />
      <Cta data={ctaData[0]} action={action} customData={customCtaFirstSection} />
      <Faq data={faqData} customData={customFaqSection} />
      <Privacy data={privacyData} customData={customPrivacySection} />
      <Cta data={ctaData[1]} action={action} customData={customCtaSecondSection} />
      <SaveQuotePartnerReferral 
        type="landing-screen"
        setQuoteSaved={setQuoteSaved}
        isQuoteSaved={isQuoteSaved}
        setEmailPrefill={(e) => setEmailPrefill(e)}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        setEmailModal={{
          enableInitialEmailCapture: enableInitialEmailCapture,
          enableTimeoutEmailCapture: enableTimeoutEmailCapture,
          initialEmailCaptureDisplayed: initialEmailCaptureDisplayed,
          timeoutEmailCaptureDisplayed: timeoutEmailCaptureDisplayed,
          isPartnerReferralEmailCaptureActive: isPartnerReferralEmailCaptureActive,
          enablePartnerReferralEmailCapture: enablePartnerReferralEmailCapture,
        }}
        modalSaveQuoteIsOpen={modalSaveQuoteIsOpen}
        setModalSaveQuoteIsOpen={setModalSaveQuoteIsOpen}
        setTimeoutEmailDisplayed={() => setTimeoutEmailDisplayed()}
        setInitialEmailDisplayed={() => setInitialEmailDisplayed()}
        saveQuoteData={saveQuoteData}
        handleContactChange={handleContactChange}
        onSubmit={onSubmit}
      />
    </Fragment>
  )
}

Term3_1.propTypes = {
  action: PropTypes.func,
  heroImages: PropTypes.object, 
  customContent: PropTypes.object, 
  isPermProductAvailable: PropTypes.bool,
  scrollToElement: PropTypes.func,
  sectionData: PropTypes.object,
}
